import { ENV } from '../../../config';

export interface CellDto {
  row: number;
  col: number;
  value: any;
  formula: string | null;
  displayValue: string;
  cellType: 'header' | 'input' | 'formula' | 'output' | 'data' | 'metadata';
  isEditable: boolean;
  numberFormat: string | null;
}

export interface SheetData {
  sheetNames: string[];
  activeSheet: string;
  cells: CellDto[];
  rowCount: number;
  colCount: number;
  namedRanges: {
    name: string;
    address: string;
    rangeType: 'input' | 'output' | 'calc' | 'data';
  }[];
}

export interface RecalcResult {
  updatedCells: (CellDto & { sheet?: string })[];
  updatedSheet: string;
  outputSummary: {
    totalIncome: number;
    partnerCount: number;
    k1Lines: Record<string, number>;
  } | null;
}

const token = () => localStorage.getItem('token') ?? '';
const headers = () => ({
  Authorization: `Bearer ${token()}`,
  tenant: ENV.TENANT_ID ?? '',
});
const BASE = `${ENV.API_URL}/api/template`;

export const TemplateEditorService = {

  getSheetData: async (
    id: number, sheet?: string
  ): Promise<SheetData> => {
    const url = `${BASE}/${id}/preview${sheet ? `?sheet=${encodeURIComponent(sheet)}` : ''}`;
    const res = await fetch(url, { headers: headers() });
    if (!res.ok) throw new Error(`Preview failed: ${res.status}`);
    return res.json();
  },

  recalculate: async (
    id: number,
    sheet: string,
    changes: { row: number; col: number; value: any }[]
  ): Promise<RecalcResult> => {
    const res = await fetch(`${BASE}/${id}/recalculate`, {
      method: 'POST',
      headers: { ...headers(), 'Content-Type': 'application/json' },
      body: JSON.stringify({ sheet, changes }),
    });
    if (!res.ok) throw new Error(`Recalc failed: ${res.status}`);
    return res.json();
  },

  saveEdits: async (
    id: number,
    changes: { sheet: string; row: number; col: number; value: any }[]
  ): Promise<any> => {
    const res = await fetch(`${BASE}/${id}/save-edits`, {
      method: 'POST',
      headers: { ...headers(), 'Content-Type': 'application/json' },
      body: JSON.stringify(changes),
    });
    if (!res.ok) throw new Error(`Save failed: ${res.status}`);
    return res.json();
  },
};
